import { useState } from 'react';
import './App.css';

import LoadImg from './components/Api';


function App(){
  return (
    <>
     <LoadImg />
    </>
  );
}

export default App;
